
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { motion } from "framer-motion";
import FortuneForm from "../components/fortune/FortuneForm";
import FortunePreview from "../components/fortune/FortunePreview";
import FortunePageHeader from "../components/fortune/FortunePageHeader";
import FortuneMessage from "../components/FortuneMessage";
import PageLayout from "../components/shared/PageLayout";

const CreateFortune = () => {
  const [showPreview, setShowPreview] = useState(false);
  const [generatedFortune, setGeneratedFortune] = useState("");

  const handleFortuneCreated = (fortune: string) => {
    setGeneratedFortune(fortune);
    setShowPreview(true);
  };

  return (
    <>
      <Helmet>
        <title>Create Your Own Fortune | Custom Fortune Cookie Messages</title>
        <meta 
          name="description" 
          content="Create your own personalized fortune cookie messages. Design custom fortunes for special occasions, share with friends, or use in homemade fortune cookies." 
        />
        <meta 
          name="keywords" 
          content="custom fortune cookie message, make your own fortune cookie online, personalized fortune message, create fortune cookie saying" 
        />
        <meta property="og:title" content="Create Your Own Fortune | Custom Fortune Cookie Messages" />
        <meta 
          property="og:description" 
          content="Our free tool lets you create custom fortune cookie messages for any occasion. Perfect for weddings, parties, or just for fun!" 
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="/create-fortune" />
        <meta property="og:image" content="/fortune-cookie-og.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Create Your Own Fortune | Custom Fortune Cookie Messages" />
        <meta 
          name="twitter:description" 
          content="Our free tool lets you create custom fortune cookie messages for any occasion. Perfect for weddings, parties, or just for fun!" 
        />
        <meta name="twitter:image" content="/fortune-cookie-og.png" />
        <link rel="canonical" href="/create-fortune" />
      </Helmet>

      <PageLayout>
        <motion.div 
          className="max-w-2xl mx-auto w-full mt-8"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <FortunePageHeader />
          
          <FortuneForm onFortuneCreated={handleFortuneCreated} />

          {generatedFortune && (
            <FortunePreview 
              generatedFortune={generatedFortune} 
              onPreviewClick={() => setShowPreview(true)} 
            />
          )}
        </motion.div>
      </PageLayout>

      {/* Preview Modal */}
      {showPreview && generatedFortune && (
        <FortuneMessage 
          fortune={generatedFortune} 
          onClose={() => setShowPreview(false)} 
        />
      )}
    </>
  );
};

export default CreateFortune;
